import { createAPIActionGenerator, APIRequest } from 'utils/apidata';

export type OauthRedirect = {
  redirect_url: string;
};

export type OauthRedirectRequest = APIRequest<OauthRedirect> & {
  provider: string;
  signUpCode: string;
};

export type OauthUnlinkRequest = APIRequest<{}> & {
  provider: string;
};

export const generators = {
  handleOauthRedirect: createAPIActionGenerator<
    OauthRedirectRequest,
    OauthRedirect
  >({
    prefix: 'OAUTH/HANDLE_REDIRECT',
  }),
  unlink: createAPIActionGenerator<OauthUnlinkRequest, {}>({
    prefix: 'OAUTH/UNLINK',
  }),
};
